export var useViewTimeOffRequestButton = function (timeoffEntries) {
    return !!timeoffEntries.length;
};
